<ng-container *ngIf="isBundleLoaded && cardDetails && !isRafLinkExpired">
  <section class="raf-page">
      <div id="cA-DD-raftaskbarContent">
        <div id="cA-DD-loginBoxContent">
          <div id="cA-DD-content" class="cA-DD-innerContent" style="padding-top: 2px;">
            <section id="cA-DD-results" class='DDL-components DDL-gridWrapped'>
              <div id="ca-DD-rafTitle">
                <h1 [innerHTML]="rafHeaderContent?.pageHeader" tabindex="-1" #pageHeader></h1>
                <h2 [innerHTML]="rafHeaderContent?.pageSubHeader" tabindex="-1" #pageSubHeader></h2>
                <div class="mobileMenu" style="border-bottom:rgba(0,0,0,0.25) 1px solid; margin-bottom:20px;"></div>
                <div
                  [ngClass]="readMore ? 'cA-DD-mainTitle-more mainTitle-readmore' : 'cA-DD-mainTitle-more mainTitle-readless'">
                  <p style='display:inline'><span [innerHtml]="rafHeaderContent?.lessData"></span>
                    <span class="readlesslinkTitle">
                      <!-- <a href="javascript:;" class="morelink"
                          [attr.aria-label]="rafHeaderContent?.readMoreLabel || ('Read More about ' + rafHeaderContent?.pageHeader)"
                          (click)="readMore = !readMore" [innerHTML]="rafHeaderContent?.readMore"></a> -->
                    </span>
                  </p>
                  <p><span class="readMoreData" [innerHtml]="rafHeaderContent?.moreData"></span><br role="presentation">
                  </p>
                </div>
              </div>
              <!-- View All Cards - Most preferred Cards  -->
              <!-- RAF Main Template -->
              <section id="rafCardsTemplate">
                <ng-container *ngFor="let cardCategoriesContent of cardCategoriesContent">
                  <div
                    [ngClass]="{'cards-bottom-border': cardCategoriesContent.categoryHeader != null && cardCategoriesContent.categoryHeader != ''}"
                    id='cardCategory-{{cardCategoriesContent.cardCategory}}' class="cardCategory">
                    <h2
                      *ngIf="cardCategoriesContent.categoryHeader != null && cardCategoriesContent.categoryHeader != ''"
                      [innerHTML]="cardCategoriesContent.categoryHeader" tabindex="-1" #rafHeader></h2>
                  </div>
                  <ng-container *ngFor="let cardListContent of cardsListOnCategories">
                    <ng-container *ngIf="cardListContent.category === cardCategoriesContent.cardCategory">
                      <div *ngFor="let allCardsContent of cardListContent.cardDetails;let i = index"
                        class="theme-gray cardsTemplate bottom-half">
                        <ng-container *ngIf="!!allCardsContent && allCardsContent?.cardTemplateName === mPPTemplateName.TEMPLATE_23">
                          <app-product-v23
                            [cardDetail]="allCardsContent"
                            [applyNowURL]="allCardsContent?.applyNowButton"
                            [learnMoreApplyLink]="allCardsContent?.learnMoreApplyLink"
                            [device]="device"
                            (addInfoClick)="openAdditionalInfoPage($event,allCardsContent?.cardName,allCardsContent?.PDPContentID)"
                            (togglecomparebutton)="togglecomparebutton($event,allCardsContent?.pdpPageLink,allCardsContent?.cardName)"
                          >
                         </app-product-v23>
                        </ng-container>
                        <ng-container *ngIf="!!allCardsContent && allCardsContent?.cardTemplateName === mPPTemplateName.TEMPLATE_1">
                          <div class="row p-25">
                            <div class="col-lg-3 col-md-3 col-sm-5 col-xs-12 text-center">
                              <div class="cardArt desktopOnly"
                                [ngClass]="{'noCardRibbon': !(allCardsContent.featureFlag && allCardsContent.featureFlag.isEnabled == 'Y')}">
                                <div *ngIf="isMobile"
                                  [ngClass]="allCardsContent.isLimitedTimeOfferAvailable === 'Y' ? 'active' : 'hidden'"
                                  class="limitedRibbon desktopOnly">
                                  <div class='cA-DD-limitedOffer' [innerHTML]="allCardsContent.limitedTimeOfferText">
                                  </div>
                                </div>
                                <h3 class="rafCardsHeaderMobile" *ngIf="isMobile" [innerHTML]="allCardsContent.cardName">
                                </h3>
                                <app-featured-flag
                                  *ngIf="allCardsContent.featureFlag && allCardsContent.featureFlag.isEnabled == 'Y'"
                                  [featuredFlag]="allCardsContent.featureFlag"></app-featured-flag>
                                <div class="card-wrapper">
                                  <app-card-art [linkHref]="allCardsContent.pdpPageLink" [pid]="allCardsContent.PID"
                                    [enablePdpLink]="true" desktopSize="md" tabletSize="md" mobileSize="tiny">
                                  </app-card-art>
                                  <div class="spacer10" role="presentation" aria-hidden="true"></div>
                                  <ui-card-rating
                                    [hidden]="!(!!allCardsContent.reviewsAvailable && allCardsContent.reviewsAvailable === 'Y')"
                                    [pid]="allCardsContent.PID"
                                    [title]="allCardsContent.cardName | friendlyname: 'stripHtml'"></ui-card-rating>
                                </div>
                                <!-- <div class="text-center prc pricing-information hidden-xs">
                                  <sup style='color:#0c71b0;font-size:50%;'>1</sup>
                                  <a class="txt-link" target="_blank" rel="noopener" [href]="allCardsContent.pricingInfoLink"
                                    attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.pricingInfo | friendlyname: 'stripHtml' }}"
                                    [innerHTML]="allCardsContent.pricingInfo"></a>
                                </div> -->
                                <div class="text-center lrn hidden-lg hidden-md hidden-xs"
                                  [ngClass]="allCardsContent.reviewsAvailable === 'Y' ? '' : '' ">
                                  <a  role="button" target="_blank" cdsButton="primary" class="" mktRouterLink="{{allCardsContent.applyNowButton}}"
                                    attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.applyNowBtnLabel |  adaFriendlyName: 'ariaLabel' }}"
                                    [innerHTML]="allCardsContent.applyNowBtnLabel"></a>
                                </div>
                                <div class="text-center lrn hidden-lg hidden-md hidden-xs"
                                [ngClass]="allCardsContent.reviewsAvailable === 'Y' ? '' : '' ">


                                  <a role="button" target="_blank" cdsButton="primary" class="lrn-more"
                                    mktRouterLink="{{allCardsContent.learnMoreApplyLink}}"
                                    attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.learnMoreApplyBtnLabel | adaFriendlyName: 'ariaLabel' }}"
                                    [innerHTML]="allCardsContent.learnMoreApplyBtnLabel"></a>

                                  <div class="col-lg-10 col-md-10 col-sm-10 pricing-information mobileOnly">
                                    <sup role="presentation" style='color:#0c71b0;'>1</sup>
                                    <a class="txt-link" target="_blank" rel="noopener" [href]="allCardsContent.pricingInfoLink"
                                      attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.pricingInfo | adaFriendlyName: 'ariaLabel' }}"
                                      [innerHTML]="allCardsContent.pricingInfo"></a>
                                  </div>

                                  <div class="col-lg-10 col-md-10 col-sm-10 pricing-information mobileOnly">
                                    <sup role="presentation" style='color:#0c71b0;'>2</sup>
                                    <a class="txt-link" role="link" target="_blank" tabindex="0" style="cursor: pointer"
                                    (click)="openAdditionalInfoPage($event,allCardsContent.cardName,allCardsContent.PDPContentID)"
                                    (keyup.Enter)="openAdditionalInfoPage($event,allCardsContent.cardName,allCardsContent.PDPContentID)"
                                    attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.additionalInformationText | adaFriendlyName: 'ariaLabel' }}"
                                    [innerHTML]="allCardsContent.additionalInformationText"></a>
                                  </div>
                                  <!-- tablet -->
                                  <div class="checkbox col-xs-12 compareCheck" *ngIf="device === 'T'">
                                    <input id="{{allCardsContent.PID}}-chkbox" [attr.data-card]="allCardsContent.cardName"
                                      class="compareChkBox"
                                      (change)="togglecomparebutton($event,allCardsContent.pdpPageLink,allCardsContent.cardName);"
                                      name="i7" type="checkbox" value="{{allCardsContent.PID}}">
                                    <label for="{{allCardsContent.PID}}-chkbox" id="{{allCardsContent.PID}}-chkboxLabel"
                                      attr.aria-label="{{allCardsContent.compareLabel + ' ' + allCardsContent.cardName | friendlyname: 'stripHtml' }}">{{allCardsContent.compareLabel}}</label>
                                  </div>
                                </div>
                              </div>
                              <div class="middlePane mobileText">
                                <div class="mobileMenu col-sm-12"
                                  style="border-bottom:rgba(0,0,0,0.25) 1px solid; margin-bottom:20px;">
                                </div>
                                <div class="text-left">
                                  <p class="nowrap rafCardText">
                                    <span style='outline:none;'
                                      [innerHtml]="allCardsContent.cardBonusOffers | safeHtml"></span>
                                  </p>
                                  <div
                                    [ngClass]="showMoreMobile ? 'cA-DD-mobileApr-readmore mobileApr-readmore' : 'cA-DD-mobileApr-readless mobileApr-readless'">
                                    <span class="showmorelinkSpan">
                                      <a href="javascript:;" aria-label='Show More'
                                        (click)="showMoreMobile = !showMoreMobile" class="showMorelink mobileOnly"> +
                                        Show More</a>
                                    </span>
                                    <div class='cardPurchaseApr mobilOnly'>
                                      <h4 [innerHTML]=" allCardsContent.purchaseRateHeaderBold "></h4>
                                      <p class="nowrap">
                                        <span style='display:block;outline:none;'
                                          [innerHtml]="allCardsContent.purchaseRateValueLight | safeHtml"></span>
                                      </p>
                                      <h4
                                        *ngIf="allCardsContent.balanceTransferHeader != null && allCardsContent.balanceTransferHeader != ''"
                                        [innerHtml]="allCardsContent.balanceTransferHeader | safeHtml"></h4>
                                      <p class="nowrap">
                                        <span
                                          *ngIf="allCardsContent.balanceTransferRate != null && allCardsContent.balanceTransferRate != undefined"
                                          style='display:block;outline:none;'
                                          [innerHtml]="allCardsContent.balanceTransferRate | safeHtml"></span>
                                      </p>
                                      <h4
                                        *ngIf="allCardsContent.annualFeeHeaderBold != null && allCardsContent.annualFeeHeaderBold != ''"
                                        [innerHtml]="allCardsContent.annualFeeHeaderBold | safeHtml"> </h4>
                                      <p class="nowrap">
                                        <span style='display:block'
                                          [innerHtml]="allCardsContent.annualFeeValueLight | safeHtml"> </span>
                                      </p>
                                      <h4
                                        *ngIf="allCardsContent.needMembershipLabel != null && allCardsContent.needMembershipLabel != ''"
                                        [innerHtml]="allCardsContent.needMembershipLabel | safeHtml"> </h4>
                                      <p *ngIf="allCardsContent.needMembershipLabel != null && allCardsContent.needMembershipLabel != ''"
                                        class="nowrap">
                                        <a attr.aria-label="{{allCardsContent.joinCostcoMembershiplabel | friendlyname: 'stripHtml'}}"
                                          href="javascript:;" role="link" tabindex="0"
                                          (click)="openModal(allCardsContent.joinCostcoMembershiplink, $event)">
                                          {{ allCardsContent.joinCostcoMembershiplabel }}
                                        </a>
                                      </p>
                                    </div>
                                    <span class="showlessSpan">
                                      <a href="javascript:;" aria-label='Show Less'
                                        (click)="showMoreMobile = !showMoreMobile" class="showLesslink mobileOnly">-
                                        Show Less</a>
                                    </span>
                                  </div>
                                </div>
                                <!-- learn more button, checkbox & pricing link only for  mobile -->
                                <div class="text-center lrn hidden-lg hidden-md" *ngIf="isMobile"
                                  [ngClass]="allCardsContent.reviewsAvailable === 'Y' ? '' : '' ">
                                  <div class="col-lg-10 col-md-10 col-sm-10">
                                  <a  role="button" target="_blank" cdsButton="primary" class="" mktRouterLink="{{allCardsContent.applyNowButton}}"
                                      attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.applyNowBtnLabel | adaFriendlyName: 'ariaLabel' }}"
                                      [innerHTML]="allCardsContent.applyNowBtnLabel"></a>
                                  </div>

                                  <div class="col-lg-10 col-md-10 col-sm-10">
                                  <a role="button" cdsButton="primary" class="lrn-more"  mktRouterLink="{{allCardsContent.learnMoreApplyLink}}"
                                    attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.learnMoreApplyBtnLabel | adaFriendlyName: 'ariaLabel' }}"
                                    [innerHTML]="allCardsContent.learnMoreApplyBtnLabel"></a>
                                  </div>

                                  <div class="col-lg-10 col-md-10 col-sm-10 pricing-information mobileOnly">
                                    <sup role="presentation" style='color:#0c71b0;'>1</sup>
                                    <a class="txt-link" target="_blank" rel="noopener" [href]="allCardsContent.pricingInfoLink"
                                      attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.pricingInfo | adaFriendlyName: 'ariaLabel' }}"
                                      [innerHTML]="allCardsContent.pricingInfo"></a>
                                  </div>

                                  <div class="col-lg-10 col-md-10 col-sm-10 pricing-information mobileOnly">
                                    <sup role="presentation" style='color:#0c71b0;'>2</sup>
                                    <a class="txt-link" role="link" target="_blank" tabindex="0" style="cursor: pointer"
                                    (click)="openAdditionalInfoPage($event,allCardsContent.cardName,allCardsContent.PDPContentID)"
                                    (keyup.Enter)="openAdditionalInfoPage($event,allCardsContent.cardName,allCardsContent.PDPContentID)"
                                    attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.additionalInformationText | adaFriendlyName: 'ariaLabel' }}"
                                    [innerHTML]="allCardsContent.additionalInformationText"></a>
                                  </div>

                                  <div class="checkbox col-xs-12 compareCheck" *ngIf="device === 'M'">
                                    <input id="{{allCardsContent.PID}}-chkbox" [attr.data-card]="allCardsContent.cardName"
                                      class="compareChkBox"
                                      (change)="togglecomparebutton($event,allCardsContent.pdpPageLink,allCardsContent.cardName);"
                                      name="i7" type="checkbox" value="{{allCardsContent.PID}}">
                                    <label for="{{allCardsContent.PID}}-chkbox" id="{{allCardsContent.PID}}-chkboxLabel"
                                      attr.aria-label="{{allCardsContent.compareLabel + ' ' + allCardsContent.cardName | adaFriendlyName: 'ariaLabel' }}">{{allCardsContent.compareLabel}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                           <!-- Desktop mode -->
                            <div class="col-lg-9 col-md-9 col-sm-7 hidden-xs">
                              <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                  <div
                                    [ngClass]="allCardsContent.isLimitedTimeOfferAvailable === 'Y' ? 'active' : 'hidden'"
                                    class="limitedRibbon desktopOnly">
                                    <div class='cA-DD-limitedOffer' [innerHTML]="allCardsContent.limitedTimeOfferText">
                                    </div>
                                  </div>
                                  <div class="common-module-col text-left">
                                    <h3 class="rafCardsHeader" *ngIf="!isMobile" [innerHTML]="allCardsContent.cardName">
                                    </h3>
                                    <p class="nowrap rafCardTextFirst">
                                      <span style='outline:none;'
                                        [innerHTML]="allCardsContent.cardDescription | safeHtml"></span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class='col-lg-8 col-md-7 col-sm-12 col-xs-12 cardPurchaseApr desktopOnly'>
                                  <p class="nowrap rafCardText">
                                    <span style='outline:none;'
                                      [innerHtml]=" allCardsContent.cardBonusOffers  | safeHtml"></span>
                                  </p>
                                  <h4 [innerHTML]=" allCardsContent.purchaseRateHeaderBold"></h4>
                                  <p class="nowrap">
                                    <span style='display:block;outline:none;'
                                      [innerHtml]="allCardsContent.purchaseRateValueLight | safeHtml "></span>
                                  </p>
                                  <h4
                                    *ngIf="allCardsContent.balanceTransferHeader != null && allCardsContent.balanceTransferHeader != ''"
                                    [innerHtml]="allCardsContent.balanceTransferHeader | safeHtml"></h4>
                                  <p class="nowrap">
                                    <span
                                      *ngIf="allCardsContent.balanceTransferRate != null && allCardsContent.balanceTransferRate != undefined"
                                      style='display:block;outline:none;'
                                      [innerHtml]="allCardsContent.balanceTransferRate | safeHtml"></span>
                                  </p>
                                  <h4
                                    *ngIf="allCardsContent.annualFeeHeaderBold != null && allCardsContent.annualFeeHeaderBold != ''"
                                    [innerHtml]="allCardsContent.annualFeeHeaderBold | safeHtml"> </h4>
                                  <p class="nowrap">
                                    <span style='display:block'
                                      [innerHtml]="allCardsContent.annualFeeValueLight  | safeHtml">
                                    </span>
                                  </p>
                                  <p class="nowrap">
                                    <sup role="presentation" style='color:#0c71b0;'>1</sup>
                                    <a class="txt-link" target="_blank" rel="noopener" [href]="allCardsContent.pricingInfoLink"
                                      attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.pricingInfo | adaFriendlyName: 'ariaLabel' }}"
                                      [innerHTML]="allCardsContent.pricingInfo"></a>
                                  </p>

                                  <p class="nowrap">
                                    <sup role="presentation" style='color:#0c71b0;'>2</sup>
                                    <a class="txt-link" role="link" target="_blank" tabindex="0" style="cursor: pointer"
                                    (click)="openAdditionalInfoPage($event,allCardsContent.cardName,allCardsContent.PDPContentID)"
                                    (keyup.Enter)="openAdditionalInfoPage($event,allCardsContent.cardName,allCardsContent.PDPContentID)"
                                    attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.additionalInformationText | adaFriendlyName: 'ariaLabel' }}"
                                    [innerHTML]="allCardsContent.additionalInformationText"></a>
                                  </p>

                                  <h4
                                    *ngIf="allCardsContent.needMembershipLabel != null && allCardsContent.needMembershipLabel != ''"
                                    [innerHtml]="allCardsContent.needMembershipLabel | safeHtml"> </h4>
                                  <p class="nowrap">
                                    <a *ngIf="allCardsContent.joinCostcoMembershiplabel != null && allCardsContent.joinCostcoMembershiplabel != ''"
                                      href="javascript:;" role="link" tabindex="0"
                                      (click)="openModal(allCardsContent.joinCostcoMembershiplink, $event)">{{
                                      allCardsContent.joinCostcoMembershiplabel }}</a>

                                  </p>
                                </div>
                                <div class="col-lg-4 col-md-5 hidden-sm hidden-xs learnMore mobileOnly"
                                  [ngClass]="allCardsContent.isLimitedTimeOfferAvailable === 'Y' ? 'offerDisplay' : 'offerNone'">
                                  <div class="text-center lrn"
                                    [ngClass]="allCardsContent.reviewsAvailable === 'Y' ? '' : '' ">
                                    <a role="button" cdsButton="primary" class="" target="_blank" mktRouterLink="{{allCardsContent.applyNowButton}}"
                                      attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.applyNowBtnLabel | adaFriendlyName: 'ariaLabel' }}"
                                      [innerHTML]="allCardsContent.applyNowBtnLabel"></a>

                                    <a role="button" cdsButton="primary" class="lrn-more"  mktRouterLink="{{allCardsContent.learnMoreApplyLink}}"
                                    attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.learnMoreApplyBtnLabel | adaFriendlyName: 'ariaLabel' }}"
                                    [innerHTML]="allCardsContent.learnMoreApplyBtnLabel"></a>

                                    <div class="col-lg-10 col-md-10 col-sm-10 pricing-information mobileOnly">
                                      <sup role="presentation" style='color:#0c71b0;'>1</sup>
                                      <a class="txt-link" target="_blank" rel="noopener" [href]="allCardsContent.pricingInfoLink"
                                        attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.pricingInfo | adaFriendlyName: 'ariaLabel' }}"
                                        [innerHTML]="allCardsContent.pricingInfo"></a>
                                    </div>

                                    <div class="col-lg-10 col-md-10 col-sm-10 pricing-information mobileOnly">
                                      <sup role="presentation" style='color:#0c71b0;'>2</sup>
                                      <a class="txt-link" role="link" target="_blank" tabindex="0" rel="noopener" style="cursor: pointer"
                                      (click)="openAdditionalInfoPage($event,allCardsContent.cardName,allCardsContent.PDPContentID)"
                                      (keyup.Enter)="openAdditionalInfoPage($event,allCardsContent.cardName,allCardsContent.PDPContentID)"
                                      attr.aria-label="{{allCardsContent.cardName + ' ' + allCardsContent.additionalInformationText | adaFriendlyName: 'ariaLabel' }}"
                                      [innerHTML]="allCardsContent.additionalInformationText"></a>
                                    </div>

                                    <div class="checkbox col-xs-12 compareCheck" *ngIf="device === 'D'">
                                      <input id="{{allCardsContent.PID}}-chkbox"
                                        [attr.data-card]="allCardsContent.cardName" class="compareChkBox"
                                        (change)="togglecomparebutton($event,allCardsContent.pdpPageLink,allCardsContent.cardName);"
                                        name="i7" type="checkbox" value="{{allCardsContent.PID}}">
                                      <label for="{{allCardsContent.PID}}-chkbox" id="{{allCardsContent.PID}}-chkboxLabel"
                                        attr.aria-label="{{allCardsContent.compareLabel + ' ' + allCardsContent.cardName | friendlyname: 'stripHtml' }}">{{allCardsContent.compareLabel}}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </section>
            </section>
          </div>
        </div>
    </div>
    <!-- Compare Shopping Cart-->
    <ng-container *ngIf="widgetSlot[0]">
      <div class="compareShoppingFooter">
        <span class="sr-only compareShoppingIntro" tabindex="0">You have {{
          widgetSlotCardCount }} items in your Cart to Compare.</span>
        <div class="comapreShoppingMyscreen">
          <div *ngFor="let widgetSlot_item of widgetSlot; let i = index"
            class="{{widgetSlot[i]}} compareShoppingContainer">
            <section [class]="widgetSlot[i]" *ngIf="!widgetSlot[i]">
              <span class="sr-only" [innerText]="'No Cart item ' + (i+1) + ' selected for compare'"></span>
              <div class="cA-cardsCompareImgSmall"></div>
            </section>
            <ng-container *ngIf="widgetSlot[i]">
              <app-card-art [pid]="widgetSlotPID[i]" [ariaLabelPrepend]="'Cart item '+ (i+1)"
                [linkHref]="widgetSlotURL[i]" [enablePdpLink]="false" [defaultSize]="'tiny'" #compareCartCardArt>
              </app-card-art>
              <div id="WidgetCloseSlot_{{i}}" role="button" tabindex="0" class="compareShoppingCloseBtn"
                [attr.aria-label]="'Remove cart item '+(i+1) + ' '+widgetSlotCardName[i] | friendlyname: 'stripHtml'"
                (click)="closeBtnClick(i)" (keydown)="closeBtnClickKeyPress($event,i)"> </div>
            </ng-container>
          </div>
          <div class="compareShoppingCompareBtn">
            <a *ngIf="compareNowBtn" tabindex="0" mktRouterLink={{compareShoppingContent.compareNowLink}}
              id="compareNowButtonEnable" (click)="compareNowBtnClick()"
              class="cA-DD-CompareShopBtn cA-DD-CompareShopBtnEnable">{{compareShoppingContent.compareNowButtonLabel}}</a>
            <a *ngIf="!compareNowBtn" role="button" tabindex="0" aria-disabled="true" id="compareNowButtonDisable"
              class="cA-DD-CompareShopBtn ">{{compareShoppingContent.compareNowButtonLabel}}</a>
          </div>
        </div>
      </div>
    </ng-container>
  </section>
</ng-container>
<app-raf-link-expired *ngIf="isRafLinkExpired"></app-raf-link-expired>
